$(document).ready(function () {
  $('#MAILING_LIST').on('submit', function (e) {
    e.preventDefault();
    var formData = {
      email: $('#email').val(),
      first_name: $('#first-name').val(),
      last_name: $('#last-name').val(),
      vehicle_year: $('#vehicle-year').val(),
      vehicle_make: $('#vehicle-make').val(),
      vehicle_model: $('#vehicle-model').val(),
      city: $('#city').val(),
      state: $('#state').val(),
      interests: [],
      current_url: window.location.href
    };
    $('input[type="checkbox"]:checked').each(function () {
      formData.interests.push($(this).val());
    });
    console.log(formData);
    $.ajax({
      url: 'https://phpstack-1280463-4977886.cloudwaysapps.com/',
      type: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(formData),
      success: function (response) {
      Swal.fire({
          title: 'Success!',
          text: 'You have joined the Mailing List successfully!',
          icon: 'success',
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            location.reload();
          }
        });
        console.log(response);
      },
      error: function (xhr, status, error) {
        alert('Error submitting form. Please try again.');
        console.log(error);
      }
    });
  });
});
